import { useQuery } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';

export interface LevelResponse {
  name: string;
  order: number;
  isCurrent: boolean;
  isCompleted: boolean;
  color: string; // 'green' | 'primary' | 'grey' | 'dark'
  isLocked?: boolean;
  tournament_id: number;
}

export interface UserLevelsResponse {
  levels: LevelResponse[];
}

export default function useGetUserLevels(enabled: boolean = true) {
  return useQuery<UserLevelsResponse>(
    ['user-levels'],
    async () => {
      // Real API call
      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await ChessRestClient.get<UserLevelsResponse>(
        `subscription/v1/get-user-levels/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      enabled,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}


